import BaseAPI from "../api";

const path: string = "/visa-request-admin";

export class VisaRequestAdminApi extends BaseAPI {
  static list(query?: any): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }
  static findById(id: any): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }
  static receive(body: any): Promise<any> {
    return this.api.patch(`${path}/receive`, body);
  }
  static reject(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/reject`, body);
  }
  static review(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/review`, body);
  }
  static teacher(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/teacher/accepting`, body);
  }
  static accepting(id: number): Promise<any> {
    return this.api.patch(`${path}/${id}/coordinator/accepting`);
  }
  static secretariatOfficer(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/secretariat-officer/accepting`, body);
  }
  static dormitoryStaff(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/dormitory-staff/accepting`, body);
  }
  static registrar(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/registrar/accepting`, body);
  }
  static exam(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/coordinator/exam`, body);
  }
  static examFile(id: number,id_visa_examination:number, body: any): Promise<any> {
    return this.api.post(`${path}/${id}/coordinator/exam/${id_visa_examination}`, body,{
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
  static divisionOfAffairsOfficer(id: number): Promise<any> {
    return this.api.patch(
      `${path}/${id}/division-of-affairs-officer/accepting`
    );
  }
  static foreignAffairsDivisionOfficer(id: number): Promise<any> {
    return this.api.patch(
      `${path}/${id}/foreign-affairs-division-officer/accepting`
    );
  }
  static courseDirector(id: number): Promise<any> {
    return this.api.patch(`${path}/${id}/course-director/accepting`);
  }
  static report(query: any): Promise<any> {
    return this.api.get(`${path}/report`, {
      params: { ...query },
      responseType: "arraybuffer",
    });
  }
}
